import React from 'react';
import { Accordion, AccordionTab } from 'primereact/accordion';
import Cookies from 'js-cookie';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import arrowUp from '../../assets/icons/new_arrow.svg';
import arrowUpBlue from '../../assets/icons/arrow_down_blue.svg';
import accordionBasket from '../../assets/icons/accordionBasket.svg';
import calendarIcon from '../../assets/icons/calendarWhite.svg';
import useWindowSize from '../../hooks/useWindowSize';
import { addToLocalBasket, addToUserBasket } from '../../store/actions/basketActions';
import callToggle from '../../store/actions/callToggle';
// test
function CustomAccordion({ data, room, isFull = false }) {
  const { translations } = useSelector((state) => state.translation);
  const dispatch = useDispatch();
  const lang = Cookies.get('i18next') || 'en';
  const { width } = useWindowSize();
  const halfwayIndex = Math.ceil(data.length / 2);
  const { isAuth, token } = useSelector((state) => state.users);
  const handleAddToBasket = async (event, item) => {
    event.stopPropagation();
    event.preventDefault();
    if (room === 'diagnostics') {
      dispatch(callToggle({ visible: true, item, isCall: false }));
    } else if (!isAuth) {
      const basket = JSON.parse(localStorage.getItem('basket')) || [];
      const index = basket.findIndex((el) => el.id === item.id);
      if (index === -1) {
        localStorage.setItem('basket', JSON.stringify([...basket, item]));
        dispatch(addToLocalBasket({ ...item }));
        toast(translations.added[lang], { type: 'success' });
      } else {
        toast(translations.alreadyAdded[lang], { type: 'warning' });
      }
    } else {
      const { payload } = await dispatch(addToUserBasket({ id: item.id, token, lang }));
      if (Array.isArray(payload)) {
        toast(translations.added[lang]);
      } else {
        toast(translations.alreadyAdded[lang], { type: 'warning' });
      }
    }
  };
  return (
    <div className="rooms_accordion">
      {width > 768 ? (
        <>
          <div
            style={{
              width: isFull ? '100%' : '',
            }}
            className="rooms_accordion_item"
          >
            <Accordion
              multiple
              collapseIcon={() => (
                <button className="accordion-collapse-btn rooms" type="button">
                  <img src={arrowUp} alt="arrow up" />
                </button>
              )}
              expandIcon={() => (
                <button className="accordion-expand-btn " type="button">
                  <img src={arrowUpBlue} alt="arrow down" />
                </button>
              )}
              className="rooms__accordion"
            >
              {data.slice(0, halfwayIndex).map((item) => (
                <AccordionTab
                  key={item.id}
                  contentClassName="faq__accordion-content rooms"
                  className="accordion-tab rooms"
                  headerClassName={item.children.length > 0 ? 'accordion-header' : 'accordion-header hidden'}
                  headerTemplate={() => (
                    <div className="accordion-header-content">
                      <p
                        role="presentation"
                        // onClick={() => navigate(`/${lang}/${"section-description"}/${item.id}`)}
                        className="accordion-header-title"
                      >
                        {item.title[lang]}
                      </p>
                      <p className="accordion-header-count">{`${item.children.length}  Services`}</p>
                    </div>
                  )}
                >
                  <Accordion
                    multiple
                    collapseIcon={() => (
                      <button className="accordion-collapse-btn rooms" type="button">
                        <img src={arrowUp} alt="arrow up" />
                      </button>
                    )}
                    expandIcon={() => (
                      <button className="accordion-expand-btn " type="button">
                        <img src={arrowUpBlue} alt="arrow down" />
                      </button>
                    )}
                    className="rooms__accordion sub"
                  >
                    {item.children.map((element) => (
                      <AccordionTab
                        key={element.id}
                        contentClassName="faq__accordion-content rooms"
                        className="accordion-tab rooms"
                        headerClassName={element.children.length > 0 ? 'accordion-header' : 'accordion-header hidden'}
                        headerTemplate={() => (
                          <div className="accordion-header-content sub">
                            <p
                              onClick={() => {
                                window.location.assign(`/${lang}/section-description/${element.slug[lang]}`);
                              }}
                              role="presentation"
                              className="accordion-header-title"
                            >
                              {element.title[lang]}
                            </p>
                            <div className="service__card-action">
                              <p>{element.price[lang]}</p>
                              {element.price[lang] && (
                              <button onClick={(event) => handleAddToBasket(event, element)} type="button">
                                <img
                                  src={room === 'diagnostics' ? calendarIcon : accordionBasket}
                                  alt="basket"
                                />
                              </button>
                              )}
                            </div>
                            {/* <p className="accordion-header-count">
                            {`${element.children.length}  Services`}</p> */}
                          </div>
                        )}
                      >
                        {element.children.map((service) => (
                          <div key={service.id} className="service__card" role="presentation">
                            <p
                              role="presentation"
                              onClick={() => window.location.assign(`/${lang}/section-description/${service.slug[lang]}`)}
                              className="service__card-title"
                            >
                              {service.title[lang]}
                            </p>
                            <div className="service__card-action">
                              <p>{service.price[lang]}</p>
                              {service.price[lang] && (
                              <button onClick={(event) => handleAddToBasket(event, service)} type="button">
                                <img
                                  src={room === 'diagnostics' ? calendarIcon : accordionBasket}
                                  alt="basket"
                                />
                              </button>
                              )}
                            </div>
                          </div>
                        ))}
                      </AccordionTab>

                    ))}
                  </Accordion>
                </AccordionTab>
              ))}
            </Accordion>
          </div>
          <div className="rooms_accordion_item">
            <Accordion
              multiple
              collapseIcon={() => (
                <button className="accordion-collapse-btn rooms" type="button">
                  <img src={arrowUp} alt="arrow up" />
                </button>
              )}
              expandIcon={() => (
                <button className="accordion-expand-btn " type="button">
                  <img src={arrowUpBlue} alt="arrow down" />
                </button>
              )}
              className="rooms__accordion"
            >
              {data.slice(halfwayIndex).map((item) => (
                <AccordionTab
                  key={item.id}
                  contentClassName="faq__accordion-content rooms"
                  className="accordion-tab rooms"
                  headerClassName={item.children.length > 0 ? 'accordion-header' : 'accordion-header hidden'}
                  headerTemplate={() => (
                    <div className="accordion-header-content">
                      <p
                        role="presentation"
                        // onClick={() => navigate(`/${lang}/${"section-description"}/${item.id}`)}
                        className="accordion-header-title"
                      >
                        {item.title[lang]}
                      </p>
                      <p className="accordion-header-count">{`${item.children.length}  Services`}</p>
                    </div>
                  )}
                >
                  <Accordion
                    multiple
                    collapseIcon={() => (
                      <button className="accordion-collapse-btn rooms" type="button">
                        <img src={arrowUp} alt="arrow up" />
                      </button>
                    )}
                    expandIcon={() => (
                      <button className="accordion-expand-btn " type="button">
                        <img src={arrowUpBlue} alt="arrow down" />
                      </button>
                    )}
                    className="rooms__accordion sub"
                  >
                    {item.children.map((element) => (
                      <AccordionTab
                        key={element.id}
                        contentClassName="faq__accordion-content rooms"
                        className="accordion-tab rooms"
                        headerClassName={element.children.length > 0 ? 'accordion-header' : 'accordion-header hidden'}
                        headerTemplate={() => (
                          <div className="accordion-header-content sub">
                            <p
                              onClick={() => window.location.assign(`/${lang}/section-description/${element.slug[lang]}`)}
                              role="presentation"
                              className="accordion-header-title"
                            >
                              {element.title[lang]}
                            </p>
                            <div className="service__card-action">
                              <p>{element.price[lang]}</p>
                              {element.price[lang] && (
                              <button onClick={(event) => handleAddToBasket(event, element)} type="button">
                                <img
                                  src={room === 'diagnostics' ? calendarIcon : accordionBasket}
                                  alt="basket"
                                />
                              </button>
                              )}
                            </div>
                            {/* <p className="accordion-header-count">
                            {`${element.children.length}  Services`}</p> */}
                          </div>
                        )}
                      >
                        {element.children.map((service) => (
                          <div key={service.id} className="service__card" role="presentation">
                            <div style={{
                              display: 'flex',
                              justifyContent: 'space-between',
                              width: '88%',
                            }}
                            >
                              <p
                                role="presentation"
                                onClick={() => window.location.assign(`/${lang}/section-description/${service.slug[lang]}`)}
                                className="service__card-title"
                              >
                                {service.title[lang]}
                              </p>
                              <p className="service-price">{service.price[lang]}</p>
                            </div>
                            <div className="service__card-action">
                              {service.price[lang] && (
                              <button onClick={(event) => handleAddToBasket(event, service)} type="button">
                                <img
                                  src={room === 'diagnostics' ? calendarIcon : accordionBasket}
                                  alt="basket"
                                />
                              </button>
                              )}
                            </div>
                          </div>
                        ))}
                      </AccordionTab>

                    ))}
                  </Accordion>
                </AccordionTab>
              ))}
            </Accordion>
          </div>
        </>
      ) : (
        <div className="rooms_accordion_item">
          <Accordion
            multiple
            collapseIcon={() => (
              <button className="accordion-collapse-btn rooms" type="button">
                <img src={arrowUp} alt="arrow up" />
              </button>
            )}
            expandIcon={() => (
              <button className="accordion-expand-btn " type="button">
                <img src={arrowUpBlue} alt="arrow down" />
              </button>
            )}
            className="rooms__accordion"
          >
            {data.map((item) => (
              <AccordionTab
                key={item.id}
                contentClassName="faq__accordion-content rooms"
                className="accordion-tab rooms"
                headerClassName={item.children.length > 0 ? 'accordion-header' : 'accordion-header hidden'}
                headerTemplate={() => (
                  <div className="accordion-header-content">
                    <p
                      role="presentation"
                      // onClick={() => navigate(`/${lang}/${"section-description"}/${item.id}`)}
                      className="accordion-header-title"
                    >
                      {item.title[lang]}
                    </p>
                    <p className="accordion-header-count">{`${item.children.length}  Services`}</p>
                  </div>
                )}
              >
                <Accordion
                  multiple
                  collapseIcon={() => (
                    <button className="accordion-collapse-btn rooms" type="button">
                      <img src={arrowUp} alt="arrow up" />
                    </button>
                  )}
                  expandIcon={() => (
                    <button className="accordion-expand-btn " type="button">
                      <img src={arrowUpBlue} alt="arrow down" />
                    </button>
                  )}
                  className="rooms__accordion sub"
                >
                  {item.children.map((element) => (
                    <AccordionTab
                      key={element.id}
                      contentClassName="faq__accordion-content rooms"
                      className="accordion-tab rooms"
                      headerClassName={element.children.length > 0 ? 'accordion-header' : 'accordion-header hidden'}
                      headerTemplate={() => (
                        <div className="accordion-header-content sub">
                          <div>
                            <p
                              onClick={() => window.location.assign(`/${lang}/section-description/${element.slug[lang]}`)}
                              role="presentation"
                              className="accordion-header-title"
                            >
                              {element.title[lang]}
                            </p>
                            <p className="service-price">{element.price[lang]}</p>
                          </div>
                          <div className="service__card-action">
                            {element.price[lang] && (
                            <button onClick={(event) => handleAddToBasket(event, element)} type="button">
                              <img
                                src={room === 'diagnostics' ? calendarIcon : accordionBasket}
                                alt="basket"
                              />
                            </button>
                            )}
                          </div>
                          {/* <p className="accordion-header-count">
                            {`${element.children.length}  Services`}</p> */}
                        </div>
                      )}
                    >
                      {element.children.map((service) => (
                        <div key={service.id} className="service__card" role="presentation">
                          <div>
                            <p
                              role="presentation"
                              onClick={() => window.location.assign(`/${lang}/section-description/${service.slug[lang]}`)}
                              className="service__card-title"
                            >
                              {service.title[lang]}
                            </p>
                            <p className="service-price">{service.price[lang]}</p>
                          </div>
                          <div className="service__card-action">
                            {service.price[lang] && (
                            <button onClick={(event) => handleAddToBasket(event, service)} type="button">
                              <img
                                src={room === 'diagnostics' ? calendarIcon : accordionBasket}
                                alt="basket"
                              />
                            </button>
                            )}
                          </div>
                        </div>
                      ))}
                    </AccordionTab>

                  ))}
                </Accordion>
              </AccordionTab>
            ))}
          </Accordion>
        </div>
      )}
    </div>
  );
}

export default CustomAccordion;
